import type { ApiResource } from "../../shared/api/resource.js";
import { stringArrayField, stringField } from "../../shared/api/resource.js";

export interface BrokerConnectionView {
  readonly id: string;
  readonly provider: string;
  readonly status: string;
  readonly updatedAt: string;
}

export interface BrokerAccountView {
  readonly capabilities: readonly string[];
  readonly connectionId: string;
  readonly displayName: string;
  readonly id: string;
  readonly providerAccountId: string;
  readonly status: string;
  readonly updatedAt: string;
}

export function connectionView(resource: ApiResource): BrokerConnectionView {
  return {
    id: resource.id,
    provider: stringField(resource, "provider", "unknown"),
    status: stringField(resource, "status", "unavailable"),
    updatedAt: stringField(resource, "updatedAt"),
  };
}

export function accountView(resource: ApiResource): BrokerAccountView {
  return {
    capabilities: stringArrayField(resource, "capabilities"),
    connectionId: stringField(resource, "connectionId"),
    displayName: stringField(resource, "displayName", "Broker account"),
    id: resource.id,
    providerAccountId: stringField(resource, "providerAccountId"),
    status: stringField(resource, "status", "unavailable"),
    updatedAt: stringField(resource, "updatedAt"),
  };
}
